import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["color", "children", "className", "style", "compact"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as styles from './styles.css';
export var SocialButton = /*#__PURE__*/function (_React$Component) {
  _inherits(SocialButton, _React$Component);

  var _super = _createSuper(SocialButton);

  function SocialButton() {
    _classCallCheck(this, SocialButton);

    return _super.apply(this, arguments);
  }

  _createClass(SocialButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          compact = _this$props.compact,
          sharedProps = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement("button", _extends({}, sharedProps, {
        type: "button"
      }, mergeStyles(styles['container'], {
        background: color
      }, className, style, compact && styles['compact'])), children);
    }
  }]);

  return SocialButton;
}(React.Component);